import { UnitService } from "./../../../services/catalogs/UnitService";
import { UnitDetail } from "../../../components/Pages/Catalogs/Unit/UnitDetail";
import { CreateUnitDto } from "../../../dtos/catalogs/unit/CreateUnitDto";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupUnit } from "../../../components/Shared/NewForms/NFLookupUnit";
import UnitList from "../../../components/Pages/Catalogs/Unit/UnitList";
import { UserDetail } from "../../../components/Pages/Catalogs/User/UserDetail";
import UserList from "../../../components/Pages/Catalogs/User/UserList";
import { NFLookupUser } from "../../../components/Shared/NewForms/NFLookupUser";
import { CreateUserDto } from "../../../dtos/catalogs/User/CreateUserDto";

export const User: IAppEntity = {
  entityType: "catalog",
  title: "User",
  pluralTitle: "User",
  apiUrl: "Users",
  apiEnum: ReferenceTypes.CatalogCompanyCashBox,

  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(UserDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(UserList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupUser, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new UnitService(this.apiUrl);
  },
  getEmptyModel(): CreateUserDto {
    return {
      userName: "",
      email: "",
      userSetting: {
        userId: "",
        phone: "",
        currentLocale: "",
        timezone: "",
        verificationType: 0,
        positionId: "",
        defaultCurrencyId: "",
        defaultCompanyId: "",
        defaultWarehouseId: "",
        // defaultDepartmentId: "",
        // defaultIncomeItemId: "",
        // defaultExpenseItemId: "",
        id: "",
      },
      // userSettingId: "",

      applicationUserId: "",
      activities: [],
      applicationUser: {
        // id: "",
      },
    };
  },
};
